import { solidstate, type _SolidState } from ":setup/qstate";
import { For, Match, Show, Switch, createEffect, createMemo, createRenderEffect } from "solid-js";
import { global } from ":shared/app";
//
import { Scoring } from "./scoring";
import type { GradingData } from "../_model";
import { Button } from ":ui/form";
import { Select } from ":ui/select";

export type Props = {
  details(): GradingData; // <model.eval.EvaluatorData["teams"][0]>;
  idx: number;
  onSubmit(props: { index: number; scores: Record<string, number | string> }): void | Promise<void>;
};
const tabs = ["survey", "track"] as const;
export default function FiltrationModal(props: Props) {
  const active_idx = solidstate.create(props.idx);
  const $participant = createMemo(() => props.details().participants[active_idx.value]);
  const $breakpoint = global.store.hooks.dom.useDedicatedBreakpoints("xs", "sm", "md", "lg");
  const $tab = solidstate.create(tabs[0] as (typeof tabs)[number]);
  const $tracker = solidstate.create({} as Record<string, number | string>);
  const $unlock_submit = createMemo(() => Object.keys($tracker.value).length >= props.details().c_keys.length + 1); // account for track key that isn't in c_keys
  const $graded = createMemo(() => $participant().filtration_id != undefined);

  // on participant changed
  createEffect(() => {
    const index = active_idx.value;
    const participant = props.details().participants[index];
    const tracker = {} as any;
    for (const key of props.details().c_keys) {
      const score = participant.scores?.[key]?.score;
      if (score != undefined) {
        tracker[key] = score;
      }
    }
    if (participant.track.answer != undefined) {
      tracker["track"] = participant.track.answer;
    }
    // console.log("changed effect :: ", participant);
    $tab.set("survey");
    $tracker.set(tracker);
  });

  function switchEntity(next: boolean) {
    const arr_length = props.details().participants.length;
    let idx = active_idx.value;
    if (next) {
      idx++;
      if (idx >= arr_length) idx = 0;
    } else {
      idx--;
      if (idx <= -1) idx = arr_length - 1;
    }
    active_idx.set(idx);
  }

  async function onSubmit() {
    const scores = $tracker.value;
    const index = active_idx.value;
    await props.onSubmit({ index, scores });
  }

  function Details() {
    return (
      <section class="flex flex-col w-full h-full gap-2 content-end items-end overflow-hidden">
        {/* details */}
        <div class="flex flex-col w-full h-full content-end justify-end children:(w-full h-fit text-brand) ">
          <p class="text-1.6em">{$participant().first_name}</p>
          <p class="text-1.6em">{$participant().last_name}</p>
          <div class="flex flex-row text-0.8em justify-between items-center <sm:(!flex-col)">
            <p class="text-text-alt ">{$participant().major}</p>
            <p class="flex flex-row gap-1 self-end">
              <span class="text-text-alt">ID:</span>
              <span class="text-brand">{$participant().id}</span>
            </p>
          </div>
        </div>
        {/* grade and submit */}
        <div class="grid grid-rows-[23%_23%_1fr] w-full h-30% items-center gap-y-2 <sm:(h-50%)">
          {/* grade */}
          <div class="flex flex-row w-full h-fit justify-between items-center text-0.8em overflow-hidden <sm:(text-0.7em)">
            <p class="text-text-alt">Grade</p>
            <p class="bg-brand-alt text-brand px2 rounded-xl text-center ">
              {$participant().scores?.total?.score ?? "Not Graded"}
            </p>
          </div>
          {/* tracks */}
          <div class="flex flex-row w-full h-fit justify-between items-center text-0.8em overflow-hidden <sm:(text-0.7em)">
            <p class="text-text-alt">Tracks</p>
            <p class="bg-brand-alt text-brand px2 rounded-xl text-center ">{$participant().tracks ?? "No Tracks"}</p>
          </div>
          <div class="flex flex-row w-full min-h-full h-full gap-1 items-center py-2 ">
            <Select
              class="form-select !rounded-16px  <sm:(!min-h-45px !h-45px)"
              options={$participant()?.track?.options ?? ["no tracks available"]}
              initialValue={$participant()?.track?.answer}
              placeholder="Track"
              onselected={(selections) => {
                const value = selections[0];
                $tracker.set((s) => ({ ...s, track: value }));
              }}
            />
            <Button
              controls={[]}
              onSubmit={onSubmit}
              class="form-btn "
              triggers={{
                manualStatus: $unlock_submit() ? "valid" : "invalid",
              }}
              statusInvalid={"Submit"}
              statusValid={$graded() ? "Update" : "Submit"}
            />
          </div>
        </div>
      </section>
    );
  }
  return (
    <Switch>
      <Match when={$breakpoint("xs", "sm")}>
        <section class="grid grid-rows-[0.1fr_1fr_0.1fr] w-full h-full gap-2 overflow-hidden children:(overflow-hidden)">
          <div class="flex flex-row w-full h-fit items-center gap-x-2">
            <For each={tabs}>
              {(item, index) => {
                return (
                  <p
                    //
                    onclick={() => $tab.set(item)}
                    class={`
                      w-full capitalize text-center text-0.8rem py-0.5 border-b-2 border-solid
                      ${$tab.value === item ? "text-brand border-brand" : "text-text-alt border-text-alt"}
                    `}
                  >
                    {item}
                  </p>
                );
              }}
            </For>
          </div>
          <div class="flex flex-col w-full h-full my-1">
            <Switch>
              <Match when={$tab.value === "survey"}>
                <Scoring
                  data={props.details()}
                  participant={$participant()}
                  onGraded={(props) => {
                    $tracker.set((s) => ({ ...s, ...props.tracker }));
                    // if (props.gradedAll) {
                    //   $unlock_submit.set(true);
                    // }
                  }}
                />
              </Match>
              <Match when={$tab.value === "track"}>
                <Details />
              </Match>
            </Switch>
          </div>
          <div class="grid grid-cols-2 w-full h-full gap-x-2 content-end children:(!h-40px !bg-bg-alt !text-text)">
            <button class="form-btn" onClick={() => switchEntity(false)}>
              Previous
            </button>
            <button class="form-btn" onClick={() => switchEntity(true)}>
              Next
            </button>
          </div>
        </section>
      </Match>
      <Match when={true}>
        <section class="grid grid-cols-[1fr_0.45fr] w-full h-full gap-x-2 py-2 overflow-hidden">
          <Scoring
            data={props.details()}
            participant={$participant()}
            onGraded={(props) => {
              $tracker.set((s) => ({ ...s, ...props.tracker }));
              // if (props.gradedAll) {
              //   $unlock_submit.set(true);
              // }
            }}
          />
          <section class="grid grid-rows-[1fr_6%] w-full h-full gap-2 overflow-hidden">
            <Details />
            {/* left and right */}
            <div class="grid grid-cols-2 w-full h-full gap-x-2 content-end children:(!h-40px !bg-bg-alt !text-text)">
              <button class="form-btn" onClick={() => switchEntity(false)}>
                Previous
              </button>
              <button class="form-btn" onClick={() => switchEntity(true)}>
                Next
              </button>
            </div>
          </section>
        </section>
      </Match>
    </Switch>
  );
}
